import { Navigate, Outlet } from "react-router-dom";

import DashboardLoading from "../Dashboard/DashboardLoading";
import { useAppSelector } from "../../hooks/storeHook";

const AuthRoutes = () => {
  const { user, initialized } = useAppSelector((state) => state.auth);

  if (!initialized) {
    return (
      <div className="min-h-screen bg-[#1c1d21] px-4 py-8 text-slate-300">
        <div className="mx-auto grid w-full max-w-5xl gap-6">
          <DashboardLoading />
        </div>
      </div>
    );
  }

  return Boolean(user) ? <Outlet /> : <Navigate to="/auth" />;
};

export default AuthRoutes;
